import React, { useEffect } from 'react'
import { IContact, INotification } from '../../models'
import StyledDiv, { Button, ContainerDiv } from './styles'
import { images } from '../../images'
import { LiteralsService } from '../../services'
import literalsService from '../../services/literals-service'
import { Application } from '../../config'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { IStoreState } from '../../store/states'
import { appsURLSSelected } from '../../helpers/app'

interface IProps {
  notification: INotification
  resetScreenParams: () => void
}

const { isIframe } = Application

export const Notification: React.FC<IProps> = ({ notification, resetScreenParams }) => {
  const isErrorNotification = notification && notification.isError

  !isErrorNotification &&
    useEffect(() => {
      setTimeout(() => {
        resetScreenParams()
      }, 5000)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

  const { serviceInfos, pickedServiceInfo, pickedOriginBusStop } = useSelector(({ newReservation }: IStoreState) => newReservation)
  const serviceInfo = serviceInfos.find((serviceInfo) => serviceInfo.id === pickedServiceInfo)
  // the route is the service direction the picked origin stop belongs to
  const routeName = serviceInfo && pickedOriginBusStop
    ? (pickedOriginBusStop.direction == 1 ? serviceInfo.backwardsDirection : serviceInfo.forwardDirection)
    : undefined

  const body = literalsService.get('mailtoBody', true)
    ?.replace('%DATETIME%', moment().format('YYYY-MM-DD HH:mm:ss'))
    .replace('%SERVICE%', serviceInfo?.name || '-')
    .replace('%ROUTE%', routeName || '-')
  const contact: IContact = {
    text: literalsService.get('contactWithUs', true),
    mail: appsURLSSelected?.supportMail ?? 'support@nemi.mobi',
    subject: '[Error] ' + (isIframe ? 'Iframe - ' : 'Webapp - ') + notification.label + ' - 500',
    body
  }

  if (!notification) return null
  return (
    <>
      <StyledDiv
        className={ isErrorNotification ? 'error' : '' }
        style={{ animationDelay: isErrorNotification ? '3700ms' : '2700ms' }}
      >
        { isErrorNotification ?
          <>
            <span>{ LiteralsService.get('someThingWentWrong', true) }</span>
            <p>{ LiteralsService.get('tryAgainOrContactSupport', true) }</p>
          </>
         : 
          <>
            <span>{ LiteralsService.get('done', true) }</span>
          </>
        }
        <ContainerDiv>
          <span>{ notification.label }</span>
          { isErrorNotification &&
            <a href={'mailto:' + contact.mail + '?subject=' + encodeURIComponent(contact.subject ?? '') + '&body=' + encodeURIComponent(contact.body ?? '')}>
              <Button>
                { contact.text }
              </Button>
            </a>
          }
        </ContainerDiv>
      </StyledDiv>
      { isErrorNotification &&
        <StyledDiv className='error'>
          <img src={ images['cross'] } alt='cross' onClick={() => resetScreenParams()} />
        </StyledDiv>
      }
    </>
  )
}
